import { useEffect, useRef } from "react";

// Simple intersection-observer based reveal wrapper.
export default function Reveal({ children, delay = 0, as = "div", className = "" }) {
  const ref = useRef(null);
  const Tag = as;

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => node.classList.add("in"), delay);
            io.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`reveal ${className}`}>
      {children}
    </Tag>
  );
}
